import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/vibranium/vibranium/src/components/Layout.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "the-scenario-file",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#the-scenario-file",
        "aria-label": "the scenario file permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`The Scenario File`}</h1>
    <p>{`The scenario file is just a combination of one or more endpoints grouped together in a file.`}</p>
    <p>{`A scenario can refer to any group, like all APIs for one entity, all endpoints doing an end to end flow or even all internal/external apis separately.`}</p>
    <h2 {...{
      "id": "important-keys",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#important-keys",
        "aria-label": "important keys permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Important keys`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`id`}</inlineCode>{` `}{`[string]`}{`: This is an auto generated ID for the scenario file. Do not change this once it is created.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`email`}</inlineCode>{` `}{`[string]`}{`: The email of the user creating the scenario. Used to mail scenario reports`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`created_on`}</inlineCode>{` `}{`[string]`}{`: A timestamp string to represent when the schema was created.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`app`}</inlineCode>{` `}{`[string]`}{`: The App name or code to represent to which app the scenario belongs to`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`name`}</inlineCode>{` `}{`[string]`}{`: The scenario name. This should be unique in the collection and is recommended to name it as the JSON file name, without the extension`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`tags`}</inlineCode>{` `}{`[string]`}{`: An optional set of tags associated with the schema. Can be used for filtering tests.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`ignore`}</inlineCode>{` `}{`[boolean]`}{`: If set to true, the scenario will be skipped/ignored while running tests.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`additionalProperties`}</inlineCode>{` `}{`[object]`}{`: Additional properties for the scenario, if any.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`scripts`}</inlineCode>{` `}{`[object]`}{`: This object contains the scripts that should be executed in the life cycle of the execution.`}<ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`before-scenario`}</inlineCode>{` `}{`[string]`}{`: The javascript that needs to be executed in the before-scenario life cycle hook`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`after-scenario`}</inlineCode>{` `}{`[string]`}{`: The javascript that needs to be executed in the after-scenario life cycle hook`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`before-each`}</inlineCode>{` `}{`[string]`}{`: The javascript that needs to be executed in the he before-each life cycle hook`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`after-each`}</inlineCode>{` `}{`[string]`}{`: The javascript that needs to be executed in the The after-each life cycle hook`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`after-globals`}</inlineCode>{` `}{`[string]`}{`: The javascript that needs to be executed in the  after-globals life cycle hook`}</li>
        </ul></li>
      <li parentName="ul"><inlineCode parentName="li">{`generate`}</inlineCode>{` `}{`[object]`}{`: The generate object is used to generate global variables for the entire schema`}<ul parentName="li">
          <li parentName="ul">{`The key is the variable name and value is the variable value`}</li>
        </ul></li>
      <li parentName="ul"><inlineCode parentName="li">{`endpoints`}</inlineCode>{` `}{`[array]`}{`: The list of endpoints`}</li>
    </ul>
    {
      /* Generated using 
      let ignoredKeys = [
       "$id",
       "examples",
       "additionalItems",
       "default",
       "title",
       "type",
       "required",
      ];
      const getObjectType = (o) => {
       if (!!o && !!o.type) {
         if (typeof o.type === "object") return `[${o.type.join(" or ")}]`;
         else return `[${o.type}]`;
       }
       return "";
      };
      Object.entries(en)
       .map(([k, v]) => {
         let lines = [`- \`${k}\` ${getObjectType(v)}: ${v.description}`],
           items = [],
           properties = [];
         if (v.items) {
           items = v.items.map((item) =>
             item[".*"]
               ? item[".*"].description
               : Object.entries(item)
                   .filter(
                     ([k, v]) => !ignoredKeys.includes(k) && typeof v === "object"
                   )
                   .map(
                     ([k, v]) =>
                       `   - \`${k}\` ${getObjectType(v)}: ${v.description}`
                   )
                   .join("\n")
           );
         } else if (v.properties && typeof v.properties === "object") {
           properties = v.properties[".*"]
             ? ["    - " + v.properties[".*"].description]
             : Object.entries(v.properties)
                 .filter(
                   ([k, v]) => !ignoredKeys.includes(k) && typeof v === "object"
                 )
                 .map(
                   ([k, v]) => `   - \`${k}\` ${getObjectType(v)}: ${v.description}`
                 );
         }
          return [...lines, ...items, ...properties].join("\n");
       })
       .join("\n");
      
      on the json below*/
    }
    <h2 {...{
      "id": "scenario-schema",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#scenario-schema",
        "aria-label": "scenario schema permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Scenario Schema`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "$schema": "http://json-schema.org/draft-06/schema",
    "$id": "scenario.json",
    "type": "object",
    "title": "The scenario schema",
    "description": "The Scenario is a JSON containing multiple endpoint tests",
    "required": [
        "id",
        "app",
        "name",
        "email",
        "endpoints",
        "created_on"
    ],
    "additionalProperties": false,
    "properties": {
        "id": {
            "$id": "#/properties/id",
            "type": "string",
            "title": "The scenario id",
            "description": "This is an auto generated ID for the scenario file. Do not change this once it is created.",
            "minLength": 36,
            "examples": [
                "2186ae65-8707-4520-bd0e-0c486670eb56"
            ]
        },
        "email": {
            "$id": "#/properties/email",
            "type": "string",
            "title": "The email of the user creating the sceario",
            "description": "The email of the user creating the scenario. Used to mail scenario reports",
            "examples": [
                "someone@domain.com"
            ]
        },
        "created_on": {
            "$id": "#/properties/created_on",
            "type": "string",
            "title": "The created on time",
            "description": "A timestamp string to represent when the schema was created.",
            "examples": [
                "2020-5-7 10:32:3"
            ]
        },
        "app": {
            "$id": "#/properties/app",
            "type": "string",
            "title": "The app name/code",
            "description": "The App name or code to represent to which app the scenario belongs to",
            "examples": [
                "exampleApp"
            ]
        },
        "name": {
            "$id": "#/properties/name",
            "type": "string",
            "title": "The scenario name",
            "description": "The scenario name. This should be unique in the collection and is recommended to name it as the JSON file name, without the extension",
            "examples": [
                "scenarioName"
            ]
        },
        "tags": {
            "$id": "#/properties/tags",
            "type": "string",
            "title": "The tags assiciated with the schema",
            "description": "An optional set of tags associated with the schema. Can be used for filtering tests.",
            "examples": [
                "crud,smoke"
            ]
        },
        "ignore": {
            "$id": "#/properties/ignore",
            "type": "boolean",
            "title": "The ignore key",
            "description": "If set to true, the scenario will be skipped/ignored while running tests.",
            "default": false,
            "enum": [
                true,
                false
            ]
        },
        "additionalProperties": {
            "$id": "#/properties/additionalProperties",
            "type": "object",
            "title": "The additionalProperties schema",
            "description": "Additional properties for the scenario, if any.",
            "additionalProperties": true
        },
        "scripts": {
            "$id": "#/properties/scripts",
            "type": "object",
            "title": "The scripts object",
            "description": "This object contains the scripts that should be executed in the lifecycle of the execution.",
            "additionalProperties": false,
            "examples": [
                {
                    "before-scenario": "",
                    "after-scenario": "",
                    "before-each": "",
                    "after-each": "",
                    "after-globals": ""
                }
            ],
            "properties": {
                "before-scenario": {
                    "$id": "#/properties/scripts/properties/before-scenario",
                    "type": "string",
                    "title": "The before-scenario schema",
                    "description": "The javascript that needs to be executed in the before-scenario lifecycle hook",
                    "examples": [
                        "logger.log('Lifecycle Hook: before-scenario')"
                    ]
                },
                "after-scenario": {
                    "$id": "#/properties/scripts/properties/after-scenario",
                    "type": "string",
                    "title": "The after-scenario schema",
                    "description": "The javascript that needs to be executed in the after-scenario lifecycle hook",
                    "examples": [
                        "logger.log('Lifecycle Hook: after-scenario')"
                    ]
                },
                "before-each": {
                    "$id": "#/properties/scripts/properties/before-each",
                    "type": "string",
                    "title": "The before-each schema",
                    "description": "The javascript that needs to be executed in the he before-each lifecycle hook",
                    "examples": [
                        "logger.log('Lifecycle Hook: before-each')"
                    ]
                },
                "after-each": {
                    "$id": "#/properties/scripts/properties/after-each",
                    "type": "string",
                    "title": "The after-each schema",
                    "description": "The javascript that needs to be executed in the The after-each lifecycle hook",
                    "examples": [
                        "logger.log('Lifecycle Hook: after-each')"
                    ]
                },
                "after-globals": {
                    "$id": "#/properties/scripts/properties/after-globals",
                    "type": "string",
                    "title": "The after-globals schema",
                    "description": "The javascript that needs to be executed in the  after-globals lifecycle hook",
                    "examples": [
                        "logger.log('Lifecycle Hook: after-globals')"
                    ]
                }
            }
        },
        "generate": {
            "$id": "#/properties/generate",
            "type": [
                "string",
                "integer",
                "boolean",
                "object",
                "array"
            ],
            "title": "The globals schema",
            "description": "The generate object is used to generate global variables for the entire schema",
            "examples": [
                {
                    "variableName": "[a-z0-9 ]{100,200}",
                    "longString": "{lorem_5000}",
                    "name": "{datasets.name}"
                }
            ],
            "additionalProperties": true,
            "properties": {
                ".*": {
                    "$id": "#/properties/generate/properties/.*",
                    "type": "string",
                    "title": "variable details",
                    "description": "Variable value",
                    "default": "",
                    "examples": [
                        "[a-z0-9 ]{100,200}"
                    ]
                }
            }
        },
        "endpoints": {
            "$id": "#/properties/endpoints",
            "type": "array",
            "title": "The endpoints schema",
            "description": "The list of endpoints",
            "additionalItems": true,
            "items": [
                {
                    "$ref": "endpoint.json"
                }
            ]
        }
    }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      